<template>
  <div>
    <el-container class="layout-container">
      <el-aside class="aside" width="auto">
        <Aside class="aside-menu" />
      </el-aside>
      <el-container>
        <el-header class="header">
          <div class="header-left">
            <span class="header-name">权限后台管理</span>
          </div>
          <el-dropdown>
            <div class="avatar-wrap" style="cursor: pointer">
              <el-avatar
                src="https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif?imageView2/1/w/80/h/80"
              ></el-avatar>
              <span style="padding-left: 10px;">{{ userName }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
             <el-dropdown-item @click.native="dialogVisible = true">修改密码</el-dropdown-item>
<!--              <el-dropdown-item @click.native="switchSystem"&ndash;&gt;切换系统</el-dropdown-item>-->
              <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-header>
        <el-main class="main">
          <!--子路由出口-->
          <keep-alive>
            <router-view v-if="$route.meta.keepalive" />
          </keep-alive>
          <router-view v-if="!$route.meta.hasOwnProperty('keepalive') || !$route.meta.keepalive" />
        </el-main>
      </el-container>
    </el-container>
    <!-- 修改用户密码 -->
    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible"
      width="30%"
      top="5vh"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="70px"
        class="demo-ruleForm"
      >
        <el-form-item label="旧密码" prop="password">
          <el-input
            type="password"
            v-model="ruleForm.password"
            placeholder="请输入旧密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="newPassWord">
          <el-input
            type="password"
            v-model="ruleForm.newPassWord"
            placeholder="请输入密码"
          ></el-input>
          <span v-if="!ruleForm.newPassWord" class="check-password-tips">密码必须包含字母，数字，长度为6-20位</span>
        </el-form-item>
        <el-form-item label="密码" prop="againConfirmPassword">
          <el-input
            type="password"
            v-model="ruleForm.againConfirmPassword"
            placeholder="请再次输入密码"
          ></el-input>
          <span v-if="!ruleForm.newPassWord" class="check-password-tips">密码必须包含字母，数字，长度为6-20位</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmChange('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Aside from "./components/Aside";
import { changePassword, layout } from "@/api/loginMange";
import {findBySystemInfo} from "../../api/loginMange";
import { rasEncryption } from '../../utils/rsa';

export default {
  name: "Layout",
  components: { Aside },
  data() {
    let reg = /(^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$)/
    let validatePass = (rule, value, callback) => {
        if (value === '') {
            return callback(new Error('请输入密码'));
        } else if (!reg.test(value)) {
            return callback(new Error('密码格式不正确(须包含字母，数字,长度6-20位)'));
        } else {
          return callback()
        }
    };
    let validatePass2 = (rule, value, callback) => {
        if (value === '') {
            return callback(new Error('请再次输入密码'));
        } else if (!reg.test(value)) {
            return callback(new Error('密码格式不正确(须包含字母，数字,长度6-20位)'));
        } else if (value !== this.ruleForm.newPassWord) {
            return callback(new Error('两次输入密码不一致!'));
        } else {
          return callback()
        }
    };
    return {
      dialogVisible: false,
      isCollpase: false,
      menuList: [],
      ruleForm: {
        password: "",
        newPassWord: "",
        againConfirmPassword: "",
        userId: "",
      },
      rules: {
        password: [
          { required: true, message: "请输入旧密码", trigger: "blur" },
        ],
        newPassWord: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePass, trigger: 'blur' }
        ],
        againConfirmPassword: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePass2, trigger: 'blur' }
        ],
      },
    };
  },
  computed: {
    userName: {
      get() {
        let userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
        if (userInfo.userName) {
          return (userInfo.groupName || "未分配") + " - " + userInfo.realName;
        }
      },
    },
  },

  // 验证是否有权限
  beforeRouteEnter(to, from, next) {
    let userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));

    // 检查系统
    if (userInfo) {
      // 获取系统信息
      findBySystemInfo(userInfo.userId).then(res => {
        if (res.code === "200") {
          let permission = res.data.find(item => item.companyId === 1)
          if (!permission) {
            next('/selectPage')
          } else {
            next()
          }
        } else {
          next('/login')
        }
      })
    }
  },

  methods: {
    // 退出登陆
    logout() {
      this.$confirm("确定退出该系统吗?", "提示")
        .then((_) => {
          // this.confirmLayout()
          window.sessionStorage.clear();
          this.$store.commit("userInfo", "");
          console.log(this.$route.query.systemType, '123123')
          if (this.$route && this.$route.query && this.$route.query.systemType) {
            this.$router.push(`/login?systemType=${this.$route.query.systemType}`);
          } else {
            this.$router.push("/login");
          }
          this.$message.success("退出成功");
        })
        .catch((_) => {});
    },
    // 修改密码
    confirmChange(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.changePassword();
        } else {
          return false;
        }
      });
    },
    // 切换系统
    switchSystem() {
      this.$confirm("确定切换系统", "提示")
        .then((_) => {
          this.$router.replace("/selectPage");
        })
        .catch((_) => {});
    },
    // 修改密码
    async changePassword() {
      let params = {
        password: rasEncryption(this.ruleForm.password),
        newPassWord: rasEncryption(this.ruleForm.newPassWord),
        againConfirmPassword: rasEncryption(this.ruleForm.againConfirmPassword),
        userCode: JSON.parse(window.sessionStorage.getItem("userInfo")).userId
      }
      const res = await changePassword(params);
      if (res.code === "200") {
        this.$message.success("修改成功,请重新登录");
        setTimeout(() => {
          this.$router.replace("/login");
        }, 1000)
      } else {
        this.$message.error(res.msg);
      }
    },
    collapseMenu() {
      this.isCollpase = !this.isCollpase;
      this.$store.commit("collapseMenu");
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped>
::v-deep .el-form-item__content{
  line-height: 20px;
}
</style>
<style scoped lang="scss">
.layout-container {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.check-password-tips{
  font-size: 12px;
  color: rgb(144, 147, 153);
}

.aside {
  background-color: #d3dce6;

  .aside-menu {
    height: 100%;

    ::v-deep .el-menu-vertical-demo {
      height: 100%;
    }
  }
}

.header {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .header-left {
    font-size: 24px;
    line-height: 24px;

    .header-name {
      font-weight: bolder;
      margin-left: 10px;
      font-size: 16px;
    }
  }
}

.main {
  background-color: #e9eef3;
}

.avatar-wrap {
  display: flex;
  align-items: center;

  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
}
</style>
